import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/logo.png'


const _hoisted_1 = {
  class: "navbar navbar-expand navbar-light d-none d-md-flex px-6",
  id: "topbar"
}
const _hoisted_2 = { class: "container-fluid" }
const _hoisted_3 = {
  "aria-label": "breadcrumb",
  class: "me-auto ms-4"
}
const _hoisted_4 = { class: "breadcrumb fw-bold" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = ["onClick"]
const _hoisted_7 = {
  class: "breadcrumb-item active d-flex align-items-center",
  "aria-current": "page"
}
const _hoisted_8 = {
  key: 0,
  class: "navbar-user"
}
const _hoisted_9 = { class: "text-subtitle me-3" }
const _hoisted_10 = { class: "dropdown-menu dropdown-menu-end cursor-pointer" }
const _hoisted_11 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, {
        to: _ctx.$paths.validator
      }, {
        default: _withCtx(() => _cache[3] || (_cache[3] = [
          _createElementVNode("img", {
            src: _imports_0,
            alt: "",
            height: "40"
          }, null, -1)
        ])),
        _: 1
      }, 8, ["to"]),
      _createElementVNode("nav", _hoisted_3, [
        _createElementVNode("ol", _hoisted_4, [
          (_ctx.link)
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 0,
                custom: "",
                to: _ctx.link
              }, {
                default: _withCtx(({ navigate }) => [
                  _createElementVNode("li", {
                    onClick: navigate,
                    class: "breadcrumb-item d-flex align-items-center"
                  }, [
                    _createElementVNode("a", null, _toDisplayString(_ctx.linkName), 1)
                  ], 8, _hoisted_5)
                ]),
                _: 1
              }, 8, ["to"]))
            : _createCommentVNode("", true),
          (_ctx.sublink)
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 1,
                custom: "",
                to: _ctx.sublink
              }, {
                default: _withCtx(({ navigate }) => [
                  _createElementVNode("li", {
                    onClick: navigate,
                    class: "breadcrumb-item d-flex align-items-center"
                  }, [
                    _createElementVNode("a", null, _toDisplayString(_ctx.sublinkName), 1)
                  ], 8, _hoisted_6)
                ]),
                _: 1
              }, 8, ["to"]))
            : _createCommentVNode("", true),
          _createElementVNode("li", _hoisted_7, _toDisplayString(_ctx.current), 1)
        ])
      ]),
      (_ctx.session)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createVNode(_component_router_link, {
              tag: "button",
              to: _ctx.$paths.validator,
              class: "btn btn-outline-primary"
            }, {
              default: _withCtx(() => _cache[4] || (_cache[4] = [
                _createTextVNode("Validar outra receita")
              ])),
              _: 1
            }, 8, ["to"]),
            _cache[6] || (_cache[6] = _createElementVNode("span", { class: "ps-4 pe-3 text-paragraph text-muted" }, "|", -1)),
            _createElementVNode("div", {
              class: "dropdown cursor-pointer align-items-center d-flex",
              onMouseover: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.avatarOver && _ctx.avatarOver(...args))),
              onMouseleave: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.avatarLeave && _ctx.avatarLeave(...args)))
            }, [
              _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.session?.name), 1),
              _cache[5] || (_cache[5] = _createElementVNode("a", {
                href: "#",
                class: "avatar avatar-sm dropdown-toggle"
              }, [
                _createElementVNode("i", { class: "fa-solid fa-user-circle display-3 text-primary" })
              ], -1)),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("span", {
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args))),
                  class: "dropdown-item text-danger"
                }, "Sair")
              ])
            ], 32)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _createVNode(_component_router_link, {
              tag: "button",
              to: _ctx.$paths.login,
              class: "btn btn-outline-primary"
            }, {
              default: _withCtx(() => _cache[7] || (_cache[7] = [
                _createTextVNode("Entrar")
              ])),
              _: 1
            }, 8, ["to"])
          ]))
    ])
  ]))
}